import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { DetailedDossierStatus, DossierStatus } from "../../types/Dossier";

export const getDossierTerminationStatus = (
  dossierId: string,
  overrideStatus: DossierStatus | null,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["dossierTerminationStatus", dossierId],
    queryFn: (): Promise<DetailedDossierStatus> => {
      return fetchWithAuth<DetailedDossierStatus>(
        "getDossierTerminationStatus",
        dossierId,
        {
          queryParams: {
            overrideStatus: overrideStatus ?? undefined,
          },
        }
      );
    },
    enabled: isQueryEnabled(options),
  });
};
